<template>
  <v-col cols="12">
    <v-toolbar dense flat>
      <v-toolbar-title>{{ $t("transmissions.transmissions") }}</v-toolbar-title>
    </v-toolbar>
    <v-divider></v-divider>
    <v-col class="py-0">
      <v-row style="align-items: center" class="menu px-0 pt-0">
        <v-col cols="12" sm="6">
          <v-autocomplete
            v-model="source"
            :items="sources"
            item-text="name"
            item-value="id"
            :label="$t('transmissions.sources')"
            class="mr-3 mt-0"
            clearable
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" sm="5">
          <v-autocomplete
            class=" mt-0"
            v-model="status"
            :items="statuses"
            item-text="name"
            item-value="name"
            :label="$t('transmissions.status')"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="1">
          <v-btn block v-on:click="resetSearch" :loading="loading">
            <v-icon>
              mdi-filter-remove-outline
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
    <CommonTable
      list-getter="projectMeteringStore/transmissionStore/getList"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      resource="transmissions"
      deleteItemDispatch="projectMeteringStore/transmissionStore/delete"
      createItemDispatch="projectMeteringStore/transmissionStore/create"
      @updated="updateList"
      :loading.sync="loading"
      :static-dispatch-params="{ project_id: this.project_id }"
      empty-text="transmissions.empty-table"
    ></CommonTable>
    <ul class="v-pagination">
      <li>
        <v-btn
          :class="['v-pagination__navigation']"
          @click="updatePage(prevUrl)"
          :disabled="!prevUrl"
          small
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </li>
      <li>
        <v-btn
          :class="['v-pagination__navigation']"
          @click="updatePage(nextUrl)"
          :disabled="!nextUrl"
          small
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </li>
    </ul>
    <Paginator
      page-getter="projectMeteringStore/transmissionStore/getPage"
    ></Paginator>
  </v-col>
</template>

<script>
import Paginator from "../../../components/common/tables/Paginator";
import CommonTable from "../../../components/common/tables/CommonTable";
import { rules } from "../../../components/mixins/rules";
import { projectTitle } from "../../../components/mixins/projects/projectTitle";
export default {
  name: "Transmissions",
  props: ["project_id"],
  mixins: [rules, projectTitle],
  components: { Paginator, CommonTable },
  data: function() {
    return {
      headers: [
        {
          text: this.$t("transmissions.receive-time"),
          align: "left",
          value: "receive_time"
        },
        {
          text: this.$t("transmissions.sender"),
          value: "sender"
        },
        {
          text: this.$t("transmissions.source"),
          value: "source_name"
        },
        {
          text: this.$t("transmissions.status"),
          value: "status"
        }
      ],
      actions: [],
      nextUrl: null,
      prevUrl: null,
      loading: false,
      source: this.$route.query.source,
      status: this.$route.query.status,
      statuses: [
        { id: 1, name: "receiving" },
        { id: 2, name: "received" },
        { id: 3, name: "processed" },
        { id: 4, name: "failed" }
      ]
    };
  },
  computed: {
    slots() {
      let project = this.$store.getters["projectStore/getItem"];
      return [
        {
          name: "receive_time",
          type: "date",
          to: "transmission",
          dateTimeZone: project.timezone,
          linkParams: {
            id: "id"
          }
        },

        {
          name: "source_name",
          type: "link",
          to: "source",
          linkParams: {
            id: "source_id"
          }
        }
      ];
    },
    getParams() {
      return `
                ${this.$route.query.limit_items}
                ${this.$route.query.orders}
                ${this.$route.query.search}
                ${this.$route.query.source}
                ${this.$route.query.status}
                `;
    },
    sources() {
      return this.$store.getters["projectMeteringStore/sourceStore/getList"];
    }
  },

  watch: {
    getParams: function() {
      this.updateList();
    },
    source: function() {
      this.search();
    },
    status: function() {
      this.search();
    }
  },
  methods: {
    getArgumentForTitle() {
      return { chain: [this.$t("transmissions.transmissions")] };
    },
    updateList() {
      this.loading = true;
      let params = this.formingParams();
      this.$store.dispatch("projectMeteringStore/transmissionStore/getList", {
        params,
        onSuccess: response => {
          this.loading = false;
          this.nextUrl = response.cursor.next;
          this.prevUrl = response.cursor.prev;
        }
      });
    },
    async updatePage(url) {
      if (!url) return;

      this.loading = true;

      try {
        await this.$store.dispatch(
          "projectMeteringStore/transmissionStore/fetchData",
          {
            url
          }
        );

        const cursor = this.$store.getters[
          "projectMeteringStore/transmissionStore/getCursor"
        ];
        this.nextUrl = cursor.next;
        this.prevUrl = cursor.prev;
      } catch (error) {
        this.$store.dispatch("notificationStore/createNotification", {
          text: this.$t("transmissions.error-parsing-data"),
          type: "error",
          value: true
        });
      } finally {
        this.loading = false;
      }
    },
    formingParams() {
      return {
        project_id: this.project_id,
        limit: this.$route.query.limit_items,
        orders:
          this.$route.query.orders ??
          "receive_time:desc/status:desc/source_id:asc",
        filters: {
          source: this.$route.query.source,
          status: this.$route.query.status
        }
      };
    },
    search() {
      let to = { ...this.$route };
      to.query = {
        ...to.query
      };
      let vm = this;
      function formQuery(name) {
        if (vm[name]) {
          to.query[name] = vm[name];
        } else {
          delete to.query[name];
        }
      }
      formQuery("source");
      formQuery("status");
      this.$router.push(to);
    },
    resetSearch() {
      this.source = "";
      this.status = "";
      let to = { ...this.$route };
      to.query = {};
      this.$router.push(to);
    }
  },
  mounted() {
    this.updateList();
    this.$store.dispatch("projectMeteringStore/sourceStore/getList", {
      params: {
        limit: -1,
        project_id: this.project_id
      }
    });
  }
};
</script>

<style scoped>
.fullScreen {
  height: calc(100vh - 48px - 24px);
  display: flex;
  flex-direction: column;
}
.fullScreen::v-deep > * {
  flex: 0 0 auto;
}
.fullScreenMobile {
  height: auto;
  display: flex;
  flex-direction: column;
}
</style>
